// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"8df613db","863":"c7d111f5"}[chunkId] + ".chunk.js";
};